import {dom, scroll} from 'quasar'
import {cleanHTML} from '../formsHelper.js'
import {StaticData} from '/src/classes/StaticData.js'

const {getScrollTarget, setVerticalScrollPosition} = scroll
const {offset} = dom

export const fldComponentsMixin = {
  methods: {
    onSetFocus(data) {
      try {
        // logger.info("onSetFocus in mixin. data.nativename: ", data.focusFieldNativename, "== formProperty.nativename: ", this.formProperty.nativename)
        if (data.focusFieldNativename === this.formProperty.nativename) {
          // logger.info("set focus to " + this.formProperty.nativename)
          this.scrollToElement2(data)
          // this.$nextTick(() => {
          setTimeout(() => {
            // let cmd = "this.$refs." + this.formProperty.nativename + ".focus()"
            try {
              let cmd = "this.$refs." + this.formProperty.nativename + ".select()"
              eval(cmd)
            } catch (e) {
            }
          }, 100)
        }
      } catch (e) {
        //console.warn(e)
      }
    },

    // takes an element object
    scrollToElement2(data) {
      const el = document.getElementById('cont_' + this.formProperty.nativename)
      const target = getScrollTarget(el)
      let fixOffset = -100
      //if (data.initialScroll) fixOffset = -150

      const offset = this.getOffsetTop(el) - el.scrollHeight + fixOffset
      const duration = 200
      //logger.info("setVerticalScrollPosition:", target, ", offset:", offset, ', top:', el.offsetTop, ', height:', el.scrollHeight)
      setVerticalScrollPosition(target, offset, duration)
    },

    scrollToElement(data) {
      setTimeout(() => {
        try {
          //logger.info("scrollToElement with ref: ", this.formProperty.nativename)
          const ele = document.getElementById('cont_' + this.formProperty.nativename)
          //const target = getScrollTarget(ele)
          let target = document.defaultView
          let fixOffset = 250
          if (data.initialScroll) fixOffset = -250
          const offset = this.getOffsetTop(ele) - ele.scrollHeight + fixOffset
          const duration = 200
          //logger.info("setVerticalScrollPosition:", target, ", offset:", offset, ', top:', ele.offsetTop, ', height:', ele.scrollHeight)
          setVerticalScrollPosition(target, offset, duration)
        } catch (e) {
          console.error("Error scrolling to ", this.formProperty.nativename)
        }
      }, 250)
    },

    getOffsetTop(element) {
      let offsetTop = 0
      while (element) {
        offsetTop += element.offsetTop
        element = element.offsetParent
      }
      return offsetTop
    },

    getHint() {
      let infoFormat = this.formProperty.paramInfoFormat ? this.formProperty.paramInfoFormat : ""
      let infoTooltip = this.formProperty.paramInfoTooltip ? this.formProperty.paramInfoTooltip : ""
      // let isRequired = this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY ? "fldReq" : ""
      return cleanHTML(infoFormat + " " + infoTooltip).trim()
    },

    getCompCSS(volatile = false) {
      let result = this.getHint() ? "q-mb-sm " : ""
      let layoutClass = volatile ? "" : " col-12"
      if (!volatile && this.formProperty.cssClass) {
        let lc = this.formProperty.cssClass.split(' ').filter(className => className.trim().startsWith('col-')).join(' ')
        if (lc) layoutClass = lc
      }
      let required = (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) ? " fldReq " : ""
      return result + required + layoutClass
    },

    getTitle() {
      // let result = (this.formProperty.titlePrefix ? this.formProperty.titlePrefix + " " : "") + this.formProperty.title
      let result = this.formProperty.title
      if (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) {
        result += "*"
      }
      return result
    }
  },

  beforeUnmount() {
    this.eventBus.off('onSetFocus', this.onSetFocus)
  },

  mounted() {
    this.eventBus.on('onSetFocus', this.onSetFocus)
  }
}



